export const BASE_URL = "https://ardhsainikcanteen.in/api/";
export const IMAGE_URL = "https://ardhsainikcanteen.in";
export const CART_DATA = "ASC_CART_DATA";
export const ACCOUNT_TYPE = "ACCOUNT_TYPE";
export const INVOICE_DATA = "INVOICE_DATA";
